<template>
    <div class="flex justify-between py-5 px-6 bg-a-black-080909 border-footer">
        <div class=" flex my-auto">
            <img class=" h-4" src="../../assets/Logo-Bzbs.svg"/>
        </div>
        <div class=" flex justify-center text-white text-14 font-Text" @click="clickPdpa()">
            <div class="font-text underline">{{lbl.paywithpoint.terms_conditions}}</div>
            <div class=" pl-0.5 my-auto">
                <img src="../../assets/icon/ic-pwp-arrow-right.svg"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PwpFooter',
    props: {
        lbl: Object,
    },
    methods: {
        clickPdpa: function () {
            this.$emit('clickPdpa')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
.font-text {
    font-family: $ff-text;
}
.font-Medium {
    font-family: $ff-Medium;
}
.font-semiBold {
    font-family: $ff-semi;
}
.border-footer {
    border-top-width: 6px;
    border-color: #494949;
}
</style>
